import { registerJdid as registerJdidToRum } from '@iheartjane/tracking';
import { useEffect } from 'react';
import { useLoaderData } from 'react-router';

import { useMemoizedRowInstance } from '@jane/bloom/hooks/dm/useMemoizedRowInstance';
import { BloomFilterProvider } from '@jane/bloom/hooks/filters';
import { useRootLoaderData } from '@jane/bloom/hooks/useRootLoaderData';
import type { SpecialResults } from '@jane/bloom/loaders/routes/dealDetail.server';

import { Deal } from './components/deal';

export function DealDetailRouteComponent() {
  const { cart, pinnedStore } = useRootLoaderData();
  const {
    applicablePriceIds,
    availableFilters,
    brandSpecials,
    breadcrumbs,
    complianceLanguage,
    currentSpecial,
    customLanguage,
    janeGold,
    jdid,
    menuProductImgsAboveTheFold,
    recommendedSortResults,
    searchCriteria,
    sort: { currentSort, sortOptions },
    specialsProducts,
    statusData,
  } = useLoaderData<SpecialResults>();
  const rowInstance = useMemoizedRowInstance(recommendedSortResults);

  useEffect(() => {
    registerJdidToRum(jdid);
  }, [jdid]);

  useEffect(() => {
    if (
      (currentSpecial.special_type === 'bundle' &&
        statusData?.qualifying_status === 'qualified') ||
      ((currentSpecial.special_type === 'cart_total' ||
        currentSpecial.special_type === 'bulk_pricing') &&
        statusData?.qualifying_status === 'applied')
    ) {
      window.scrollTo({
        behavior: 'smooth',
        left: 0,
        top: 0,
      });
    }
  }, [currentSpecial.special_type, statusData?.qualifying_status]);

  return (
    <BloomFilterProvider
      availableFilters={availableFilters}
      searchCriteria={searchCriteria}
    >
      <Deal
        brandSpecials={brandSpecials}
        breadcrumbs={breadcrumbs}
        preloadedProductIds={menuProductImgsAboveTheFold.map(({ id }) => id)}
        complianceLanguage={complianceLanguage}
        currentSpecial={currentSpecial}
        specialsProducts={specialsProducts}
        rowInstance={rowInstance}
        cart={cart}
        currentSort={currentSort}
        sortOptions={sortOptions}
        customLanguage={customLanguage}
        applicablePriceIds={applicablePriceIds}
        janeGold={janeGold}
        pinnedStore={pinnedStore}
        statusData={statusData}
      />
    </BloomFilterProvider>
  );
}
